import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/Rx';
import * as _ from 'lodash';
import { Constants } from './shared/models/constants';
import { InboxBookData } from './shared/models/inboxBookData';
import { InboxBids } from './shared/models/inboxBids';
import { ShelfPouchDb } from './shelf/shelf.pouchdb.service';
import { Http, Response, RequestOptions, Headers, RequestOptionsArgs } from '@angular/http';
import { HttpHeaders } from '@angular/common/http';
import { LOGIN_MUTATION_QUERY } from './shared/models/query';


@Injectable()
export class Component_interactionService {

    private onBookClick = new BehaviorSubject<any>({});
    cast = this.onBookClick.asObservable();

    private updatingBooks = new BehaviorSubject<any>([]);
    cast1 = this.updatingBooks.asObservable();


    private answerSheetLength = new BehaviorSubject<any>([]);
    answerSheetLength$ = this.answerSheetLength.asObservable();

    private updatingAnswerSheets = new BehaviorSubject<any>([]);
    updatingAnswerSheets$ = this.updatingAnswerSheets.asObservable();

    public localDB;
    public remoteDB;
    formedBooksArr = [];
    uniqBooksArray = [];
    uniquebookid: any;


    preparedBookIdsDataArray = [];
    inboxBids: any;

    constructor(private http: Http) { }

    selectedBookData(data) {

        this.onBookClick.next(data);
    }

    updateBooksData(data) {
        this.updatingBooks.next(data);
    }

    updateAnswerSheet(localdb, remotedb, docs) {
        this.localDB = localdb;
        this.remoteDB = remotedb;
        console.log('data');
        this.answerSheetLength.next(docs.length)
        this.updatingAnswerSheets.next(docs);

        // parent.window.document['shelfCompThis'].updateanswerSheetLength(info.change.docs.length);

    }

    updateInboxData(localdb, remotedb, length) {

        var self = this;

        localdb.find({
            selector: { type: "export" },
        }).then(function (doc) {
            var exportDocs = _.filter(doc.docs, function (doc) {
                return doc.type == 'export' && doc._deleted != true
            })

            self.loadInboxBids(localdb, remotedb, exportDocs, length);

        })

    }

    loadInboxBids(localdb, remotedb, info, length) {
        this.localDB = localdb;
        this.remoteDB = remotedb;

        var ExportArray = [];

        var self = this;

        for (var i = 0; i < info.length; i++) {

            var obj = info[i];

            if (obj.type == 'export') {

                if (obj.from != Constants.USER) {

                    ExportArray.push(obj);
                }
            }
        }

        // if (length == '') self.prepareInboxIdsDoc(length, ExportArray);
        // else self.prepareInboxIdsDoc(length, ExportArray);

        self.prepareInboxIdsDoc(length, ExportArray);

    }

    public inboxDoucment: any

    prepareInboxIdsDoc(length, info) {


        var self = this;

        this.localDB.find({
            selector: { type: 'inboxBids' },
        }).then(function (result) {


            if (result.docs.length == 0) {

                self.prepareAndUpdateInboxBids();
            }

            else {

                self.modifyAndUpdateInboxBids(result.docs[0], info).then(function (doc) {

                    self.inboxDoucment = doc;
                    self.inboxDoucment._rev = result.docs[0]._rev;

                    return self.localDB.put(self.inboxDoucment).then(function (files) {

                        var docs = [];
                        docs.push(self.inboxDoucment._id);

                        // self.localDB.replicate.to(self.remoteDB, {
                        //     live: false,
                        //     doc_ids: docs
                        // })

                        parent.window.document['mycompthis'].getExportData(self.inboxDoucment, length, info);
                    });

                }).catch(function (err) {


                });

            }

        }).then(function (response) {
        }).catch(function (err) {
            console.log(err);
        });

    }

    modifyAndUpdateInboxBids(docs, info) {


        return new Promise((resolve, reject) => {


            for (var i = 0; i < info.length; i++) {

                var a = {
                    "isDeleted": info[i].isDeleted,
                    "isDownloaded": info[i].isDownloaded,
                    "shareCount": info[i].shareCount,

                }

                if (docs[info[i].book._id]) {

                    if (docs[info[i].book._id]['bids'][info[i]._id]) {
                        // a["isDeleted"] = docs[info[i].book._id]['bids'][info[i]._id].

                    }
                    else docs[info[i].book._id]['bids'][info[i]._id] = a;
                }

                else {

                    docs[info[i].book._id] = {};

                    docs[info[i].book._id]['bids'] = {};

                    docs[info[i].book._id]['bids'][info[i]._id] = a;

                }
                if (docs[info[i].book._id].senders)

                    docs[info[i].book._id].senders.push(info[i].sender)

                else {
                    docs[info[i].book._id].senders = [];
                    docs[info[i].book._id].senders.push(info[i].sender)
                }

                docs[info[i].book._id]['tmp_inbox'] = Math.floor(Date.now() / 1000);;

            }

            resolve(docs);

        });

    }

    singleBookdata = [];
    uniqueBookArrayChildren: any;
    prepareAndUpdateInboxBids() {




        var self = this;

        this.inboxBids = new InboxBids();
        var timestamp = Constants.getGUID();

        var uniqueBookIds = [];

        this.inboxBids._id = Constants.USER + ".inboxBids";


        this.localDB.find({
            selector: { type: 'export' },
        }).then(function (doc) {

            var temp = _.filter(doc.docs, function (o) { return o.from != Constants.USER; });

            self.uniqBooksArray = _.uniqBy(temp, function (e) {

                self.uniquebookid = e;

                return self.uniquebookid.bId;
            });

            for (var i = 0; i < self.uniqBooksArray.length; i++) {

                var obj = {
                    'index': i,
                    'booksArray': [],
                    'book': {}
                }


                self.singleBookdata = _.filter(temp, function (o) {
                    self.uniqueBookArrayChildren = o;
                    return self.uniqueBookArrayChildren.bId == self.uniqBooksArray[i].bId;
                });
                obj.book = self.singleBookdata[0].book;
                obj.booksArray = self.singleBookdata;
                self.formedBooksArr.push(obj);

            }



            _.forEach(self.formedBooksArr, function (data) {
                self.preparedBookIdsDataArray = [];

                self.inboxBids[data.book._id] = {};
                var exportObj = {};
                var bidObj = {};
                var sendersArr = [];
                _.forEach(data.booksArray, function (exportArray) {

                    var a = {
                        "isDeleted": exportArray.isDeleted,
                        "isDownloaded": exportArray.isDownloaded,
                        "shareCount": exportArray.shareCount,

                    }
                    exportObj[exportArray._id] = a;

                    sendersArr.push(exportArray.sender)

                });

                self.inboxBids[data.book._id]['bids'] = exportObj;
                self.inboxBids[data.book._id]['senders'] = sendersArr;

                self.inboxBids[data.book._id]['tmp_inbox'] = Math.floor(Date.now() / 1000);;

            });



            self.localDB.put(self.inboxBids).then(function (response) {

                var docs = [];
                docs.push(self.inboxBids._id);

                // self.localDB.replicate.to(self.remoteDB, {
                //     live: false,
                //     doc_ids: docs
                // })

                parent.window.document['mycompthis'].getExportData(self.inboxBids, length);
            });

        })
    }
    connectingToNAS_Server(info) {

        return new Promise((resolve, reject) => {
            this.http.post('http://' + Constants.nasUrl, {
                "query": LOGIN_MUTATION_QUERY,
                variables: {
                    "token": info.idToken
                }
            }).subscribe(res => {
                localStorage.nasResponse = JSON.stringify(res.json().data);
                resolve(res.json().data);
            }
            )
        })
    }

    connectingToLCS_Server(data, state) {
        var self = this;
        const headers = new Headers();
        localStorage.userToken = data.signIn.token;
        headers.append('Authorization', 'Bearer ' + data.signIn.token);
        const options = new RequestOptions({ headers: headers });
        return new Promise((resolve, reject) => {
            this.http.post(
                "http://" + Constants.lcsUrl + "/graphql", {
                    "query": 'mutation{  getSyncGatewaySesson{    session_id    cookie_name    expires defaultShelf }}',
                },
                options
            ).subscribe(res => {
                localStorage.lastAppOpenedOn = new Date();
                localStorage.sessionExpiresOn = res.json().data.getSyncGatewaySesson.expires;
                localStorage.defaultShelf = res.json().data.getSyncGatewaySesson.defaultShelf
                self.setCookie(res.json().data.getSyncGatewaySesson.cookie_name, res.json().data.getSyncGatewaySesson.session_id, res.json().data.getSyncGatewaySesson.expires);
                resolve(res.json().data);
            });
        });
    }

    setCookie(name, value, days) {
        document.cookie = name + "=" + (value || "") + days + "; path=/";
    }

}



// WEBPACK FOOTER //
// ./src/app/component_interaction.service.ts